const usd = (v) => (v == null ? "—" : `${v < 0 ? "-" : "+"}$${Math.abs(v).toFixed(2)}`);
const LINES = [["spread_usd", "spread"], ["commission_usd", "commissions"], ["exchange_fee_usd", "exchange fees"], ["slippage_usd", "exp. slippage"], ["latency_usd", "latency penalty"]];

export const MbtEdgeHeadline = ({ edge, score }) => {
  const ok = edge && !edge.pass;
  const color = !edge ? "var(--r2-text2)" : ok ? "var(--r2-emerald)" : "var(--r2-red)";
  return (
    <div className="flex items-baseline gap-1.5" data-testid="mbt2-edge-headline" title="NET EDGE = E[favourable excursion] − E[adverse excursion] − spread − commissions − exchange fees − expected slippage − latency penalty. Trade only if edge > safety buffer.">
      <span className="text-[6.5px] uppercase tracking-[0.18em] text-[var(--r2-text2)]">net edge</span>
      <span className="r2-num text-[12px] font-bold" style={{ color }} data-testid="mbt2-net-edge">{edge ? usd(edge.net_edge) : "—"}</span>
      <span className="text-[7px] text-[var(--r2-text2)]">/ct · buffer ${edge ? edge.buffer_usd.toFixed(2) : "—"}</span>
      <span className="text-[7px] text-[var(--r2-text2)]" data-testid="mbt2-score">score {score ?? "—"}</span>
    </div>
  );
};

export const MbtEdgeWaterfall = ({ edge }) => {
  if (!edge) return null;
  const Row = ({ label, v, bold, color, testid }) => (
    <div className={`flex justify-between ${bold ? "font-bold" : ""}`} data-testid={testid}>
      <span className="text-[var(--r2-text2)]">{label}</span><span className="r2-num" style={{ color: color || "var(--r2-text1)" }}>{usd(v)}</span>
    </div>
  );
  const max = Math.max(edge.efe_usd, edge.eae_usd, edge.cost_usd, 0.01);
  const bar = (v, c) => <div className="h-[3px] rounded-sm" style={{ width: `${Math.min(100, (v / max) * 100)}%`, background: c }} />;
  return (
    <div className="grid grid-cols-[1fr_1fr] gap-x-4 rounded-sm border border-[var(--r2-border)] bg-black/20 px-2 py-1" data-testid="mbt2-edge-waterfall">
      <div>
        <Row label={`E[favourable] ${edge.efe_r}R`} v={edge.efe_usd} color="var(--r2-emerald)" testid="mbt2-edge-efe" />{bar(edge.efe_usd, "var(--r2-emerald)")}
        <Row label={`E[adverse] ${edge.eae_r}R`} v={-edge.eae_usd} color="var(--r2-red)" testid="mbt2-edge-eae" />{bar(edge.eae_usd, "var(--r2-red)")}
        <Row label="gross edge" v={edge.gross_edge} bold />
        <div className="mt-[2px] text-[7px] text-[var(--r2-text2)]" data-testid="mbt2-edge-bucket">state {edge.bucket} · n{edge.bucket_n} · evidence {Math.round(edge.shrink * 100)}%{edge.bucket_n === 0 ? " · no evidence → neutral prior" : ""}</div>
      </div>
      <div>
        {LINES.map(([k, l]) => <Row key={k} label={l} v={-(edge.cost_lines?.[k] ?? 0)} testid={`mbt2-edge-${k}`} />)}
        <Row label={edge.pass ? "NET EDGE → PASS" : "NET EDGE → TRADEABLE"} v={edge.net_edge} bold color={edge.pass ? "var(--r2-red)" : "var(--r2-emerald)"} testid="mbt2-edge-net" />
      </div>
    </div>
  );
};
